import { DateTime } from 'luxon';

import { logintimeChange } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
// import { XAPI } from '@holmescorp/xapi';
import { Agent } from '@holmescorp/xapi/classes/agent';

export const login = (actor: Agent, loginTime?: string, logoutTime?: string): void => {
	const {
		// portal_site: site,
		portal_userid: userid,
		// product,
		// xapi_urn_prefix: prefix,
		// portal_locale,
		// hash,
		// association,
		// course_session,
		sessionid
	} = window.hcstatic;

	const recordLogin = (now: string): void => {
		logintimeChange({ logintime: now });
		// const {
		// 	Verbs: { LOGGED_IN },
		// 	svc: { set_statement },
		// 	Activity,
		// 	Context,
		// 	Statement
		// } = XAPI;

		// const extensions: { [key: string]: any } = {
		// 	language: portal_locale,
		// 	revision: hash
		// };
		// extensions[`${prefix}login-time`] = now;
		// extensions[`${prefix}course_id`] = course_session?.pk;

		// const loginStmt = new Statement({
		// 	actor,
		// 	verb: LOGGED_IN,
		// 	target: new Activity({ id: `${prefix}${association?.toLowerCase()}:${product?.toLowerCase()}` }),
		// 	context: new Context({ extensions })
		// });
		// set_statement({ stmnt: loginStmt.asVersion(), site });
	};

	const now = DateTime.now();
	if (loginTime) {
		if (logoutTime) {
			const lastLoginTime = DateTime.fromISO(loginTime);
			const lastLogoutTime = DateTime.fromISO(logoutTime);
			const loginLogoutDiff = lastLogoutTime.diff(lastLoginTime).as('hours');
			const logoutNowDiff = now.diff(lastLogoutTime).as('hours');
			const okToLogin = loginLogoutDiff > 0 && logoutNowDiff > 0;
			if (okToLogin) {
				recordLogin(now.toISO());
			}
		}
	} else {
		recordLogin(now.toISO());
	}

	publish('notify:event', {
		event: 'remote:site:login',
		recipient: userid,
		'from-sessionid': sessionid,
		echo: false,
		message: {
			action: 'login',
			userid: userid
		}
	});
};
